export default {
  error_messages: {
    failed_to_fetch_orders:
      'Daten konnten nicht geladen werden. Bitte klicke auf das „Aktualisieren“-Symbol oder versuche es in 1 Minute erneut.',
    something_went_wrong: 'Etwas ist schiefgelaufen, bitte versuche es erneut.',
  },
};
